<template>
  <transition name="fullscreen" @before-leave="beforeLeave">
    <div class="ccontainer" v-if="fullscreen.enabled" :class="touchEnabled ? 'no-hover' : ''">
      <!-- We need an another div to seperate transition duration from ccontainer -->
      <div class="text-glow" style="height:100%">
        <div class="container">
          <div class="fade-overlay" @click="close"></div>
          <div class="header">
            <div></div>
            <div class="counter" :style="single ? 'visibility:hidden' : ''">{{current+1}}/{{total}}</div>
            <div class="x drop-shadow-glow" @click.stop="close">x</div>
          </div>
          <div>
            <!-- Multiple Images -->
            <picture-carousel
              v-if="!single"
              :pictures="pictures"
              class="carousel"
              :centerHover="false"
              :pagination="false"
              ref="carousel"
              @change="updateCounter"
            />
            <!-- Single Image -->
            <img v-else :src="imageSrc" class="single-image" />
          </div>
          <!-- invis for flex -->
          <div class="invis"></div>
        </div>

        <div class="gradient"></div>

        <!-- Left nav -->
        <div v-if="!single" class="left navbar" @click="decCurrent">
          <div class="appear-transition">«</div>
        </div>
        <!-- Right nav -->
        <div v-if="!single" class="right navbar" @click="incCurrent">
          <div class="appear-transition">»</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
/**
 * Handles full screen mode when viewing an image
 */
import PictureCarousel from "./picture-carousel"
import StoreUtils from "@/scripts/utils/store"
import store from "@/store"
import { mapState } from "vuex"
export default {
  components: {
    PictureCarousel
  },
  data() {
    return {
      current: 0,
      scrollY: 0,
      storeWatch: null
    }
  },
  computed: {
    // if we only have one picture
    single() {
      return this.total === 1
    },
    pictures() {
      return this.fullscreen.pictures
    },
    total() {
      return this.pictures.length
    },
    imageSrc() {
      return require("@/assets/project-synthecite/" + this.pictures[this.current])
    },
    ...mapState({
      fullscreen: state => state.projectSynthecite.fullscreen,
      touchEnabled: state => state.touchEnabled
    })
  },
  created() {
    //temp
    this.storeWatch = StoreUtils.WatchFullscreen(
      this.enterFullscreen,
      this.exitFullscreen
    )
  },
  beforeDestroy() {
    this.storeWatch()
  },
  methods: {
    /**
     * For some reason vue isnt letting me apply a style to the parent
     * when the transition is taking place, so i have to add a style here
     * that counter acts the styling done in "parent" class (width: calc(100% - 10px))
     */
    beforeLeave(el) {
      if (!this.touchEnabled) {
        el.style.width = "calc(100% + 10px)"
      }
    },
    /**
     * Closes fullscreen
     */
    close() {
      store.commit("setFullscreen", { enabled: false })
    },

    /**
     * Initializes and opens full screen viewer
     */
    enterFullscreen({ selectedIndex }) {
      document.documentElement.style.overflow = "hidden"
      this.current = selectedIndex
      this.scrollY = window.scrollY
      // ref isnt ready yet (v-if) so we wait
      this.$nextTick(() => {
        // only set if we are  carousel
        if (!this.single) {
          this.$refs.carousel.setIndex(selectedIndex)
        }
      })
    },
    /**
     * Performs shut down of full screen viewer
     */
    exitFullscreen() {
      document.documentElement.style.overflow = "auto"
      window.scrollTo(0, this.scrollY)
    },

    /* Pagination */
    incCurrent() {
      this.$refs.carousel.increaseCarousel(1)
    },
    decCurrent() {
      this.$refs.carousel.decreaseCarousel(1)
    },
    updateCounter(e) {
      this.current = e
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/views/project-synthecite/styles/variables.scss";

.ccontainer {
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  user-select: none;
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  width: 100%;
}

.header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1;
  // We do this because the header takes up a lot of space
  // useful for leaving fullscreen
  pointer-events: none;
}

.header,
.invis {
  height: 10%;
}

.parent {
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.gradient {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  pointer-events: none;
}
.navbar {
  position: absolute;
  top: 0;
  width: 5%;
  line-height: 0px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.left.navbar {
  left: 0;
  align-items: flex-start;
  padding-left: 5%;
}
.right.navbar {
  right: 0;
  align-items: flex-end;
  padding-right: 5%;
}

@media only screen and (max-width: 500px) {
  .navbar {
    display: none;
  }
}

.header,
.navbar {
  font-size: 10vh;
}

.x {
  position: relative;
  right: 5%;
  cursor: pointer;
  pointer-events: auto;
}
.x,
.navbar {
  cursor: pointer;
  transition: 0.5s all;
  background-color: transparent;
}
.ccontainer:not(.no-hover) .x:hover,
.ccontainer:not(.no-hover) .navbar:hover {
  color: rgba($green, 0.5);
  filter: drop-shadow(0px 0px $drop-shadow-length rgba($green, 1));
  animation-play-state: paused;
  font-size: 11vh;
}
@media only screen and (min-height: 450px) {
  .header,
  .navbar {
    font-size: 50px;
  }
  .ccontainer:not(.no-hover) .x:hover,
  .ccontainer:not(.no-hover) .navbar:hover {
    font-size: 55px;
  }
}

.appear-transition {
  position: relative;
}
.left .appear-transition {
  animation: 1s left-appear ease;
}
@keyframes left-appear {
  0% {
    left: 10px;
  }
  100% {
    left: 0px;
  }
}
.right .appear-transition {
  animation: 1s right-appear ease;
}
@keyframes right-appear {
  0% {
    right: 10px;
  }
  100% {
    right: 0px;
  }
}

.fade-overlay {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.9);
}

.back-click {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.carousel {
  width: 100%;
  height: 75vh;
}
.single-image {
  max-height: 85vh;
  max-width: 95%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  filter: drop-shadow(0px 0px 5px);
  border-radius: 5px;
}

/* Animations */
/* NOTE: Dont do 'all' since we do a width style and we need that to be instant
   This is for the stupid scroll style not applying
*/
.fullscreen-enter-active {
  transition: 0.5s opacity;
}
.fullscreen-leave-active {
  transition: 0.25s opacity;
}
.fullscreen-leave-to,
.fullscreen-enter {
  opacity: 0;
}
</style>